import { ActiveMenuItem } from '@/app/constants/menuItem'
import moment from 'moment'
import type { Moment } from 'moment'
import { OutputType } from '@/app/constants/outputType'
import { DatePickerRangeProps, DatePickerProps } from '@/modules/drivers/types'
import * as React from 'react'
import { useDateStore } from '@/modules/drivers/stores/dateStore'

function toDatePickerProps(m: Moment): DatePickerProps {
  return {
    fullDate: m.format('YYYY-MM-DD'),
    year: m.year(),
    month: m.month() + 1,
    day: m.date(),
  }
}

function getInitialDateRange(): DatePickerRangeProps {
  const storeRange = useDateStore.getState().range
  if (storeRange) return storeRange

  const storedMonth = useDateStore.getState().month
  if (storedMonth) {
    const [y, m] = storedMonth.split('-').map(Number)
    const first = moment({ year: y, month: m - 1, day: 1 })
    const last = moment({ year: y, month: m - 1 }).endOf('month')
    return {
      startDate: toDatePickerProps(first),
      endDate: toDatePickerProps(last),
    }
  }

  const now = moment()
  const monthAgo = moment().subtract(1, 'month')
  return {
    startDate: toDatePickerProps(monthAgo),
    endDate: toDatePickerProps(now),
  }
}

const RaportFormContext = React.createContext<any | null>(null)
export const RaportFormProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [driverMode, setDriverMode] = React.useState<ActiveMenuItem>(
    ActiveMenuItem.PRINTOUT_DRIVER,
  )
  const [dateRange, setDateRange] =
    React.useState<DatePickerRangeProps>(getInitialDateRange)
  const [outputType, setOutputType] = React.useState<OutputType>(OutputType.Pdf)
  const [data, setData] = React.useState({})
  const value = React.useMemo(
    () => ({
      setData,
      data,
      driverMode,
      setDriverMode,
      dateRange,
      setDateRange,
      setOutputType,
      outputType,
    }),
    [data, driverMode, dateRange, outputType],
  )

  return (
    <RaportFormContext.Provider value={value}>
      {children}
    </RaportFormContext.Provider>
  )
}

export const useRaportForm = () => {
  const ctx = React.useContext(RaportFormContext)
  if (!ctx)
    throw new Error('useRaportForm must be used within RaportFormProvider')
  return ctx
}
